const SHARED_FEATURES = [
'+79.000 Canais, +249.000 Filmes E Séries',
'Amazon Prime, HBO Max, Netflix, Apple TV+, Disney+, Discovery+, Viaplay e muito mais...',
'Assistir à Sport TV Portugal Em Direto No TVPortugal4k',
'Fórmula 1 em direto na Sport TV com TVPortugal4k',
'Escolha Ilimitada De Filmes E Séries',
'Qualidade SD / HD / FULL HD / 4K / 8K',
'Servidores Rápidos E Estáveis',
'Compatível Com Todos Os Dispositivos',
'Atualizações Regulares',
'15 Dias De Garantia De Reembolso',
];

export const STANDARD_PLANS = [
  {
    id: 'basic',
    title: 'PACOTE BÁSICO',
    originalPrice: '39,00 €',
    price: '29,00 €',
    period: '12 MESES',
    badge: null,
    screens: 1,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=29',
    features: SHARED_FEATURES,
    showAdultContent: false,
  },
  {
    id: 'premium',
    title: 'PACOTE PREMIUM',
    originalPrice: '49,00 €',
    price: '39,00 €',
    period: '24 MESES',
    badge: 'MAIS POPULAR',
    screens: 1,
    isPopular: true,
    link: 'https://laligaiptv.com/order.php?id=39',
    features: ['Canais + Filmes para Adultos (com palavra-passe) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
  {
    id: 'gold',
    title: 'PACOTE OURO',
    originalPrice: '59,00 €',
    price: '49,00 €',
    period: '18 MESES',
    badge: 'MELHOR PREÇO',
    screens: 2,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=49',
    features: ['Canais + Filmes para Adultos (com palavra-passe) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
];

export const MULTI_SCREEN_PLANS = [
  {
    id: 'multi-2y',
    title: 'PACOTE DIAMANTE',
    originalPrice: '69,00 €',
    price: '59,00 €',
    period: '24 MESES',
    badge: null,
    screens: 2,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=59',
    features: SHARED_FEATURES,
    showAdultContent: false,
  },
  {
    id: 'multi-3s',
    title: 'PACOTE FAMILIAR 3 ECRÃS',
    originalPrice: '79,00 €',
    price: '69,00 €',
    period: '18 MESES',
    badge: 'MAIS POPULAR',
    screens: 3,
    isPopular: true,
    link: 'https://laligaiptv.com/order.php?id=69',
    features: ['Canais + Filmes para Adultos (com palavra-passe) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
  {
    id: 'multi-4s',
    title: 'PACOTE FAMILIAR 4 ECRÃS',
    originalPrice: '99,00 €',
    price: '89,00 €',
    period: '18 MESES',
    badge: 'MELHOR VALOR',
    screens: 4,
    isPopular: false,
    link: 'https://laligaiptv.com/order.php?id=89',
    features: ['Canais + Filmes para Adultos (com palavra-passe) 🔞', ...SHARED_FEATURES],
    showAdultContent: true,
  },
];

export const LIFETIME_PLAN = {
  title: 'PACOTE PARA A VIDA',
  originalPrice: '149,00 €',
  price: '119,00 €',
  period: 'único',
  badge: 'OFERTA LIMITADA',
  link: 'https://laligaiptv.com/order.php?id=119',
};
